export default __webpack_public_path__ + "static/media/Metal.4bfb2950.svg";